/* RESPONSIBLE TEAM: team-messenger */
import IntercomRoute from 'embercom/routes/base/intercom-route';
import { inject as service } from '@ember/service';
import type MessengerSettingsService from 'embercom/services/messenger-settings-service';
import type MessengerSettingsTargetUserProvider from 'embercom/services/messenger-settings-target-user-provider';
import type Transition from '@ember/routing/transition';
import { DEFAULT_SECTIONS_FOR_TABS } from 'embercom/services/messenger-settings-service';
import type Router from '@ember/routing/router-service';
import type IntlService from 'ember-intl/services/intl';

export default class MessengerGeneralRoute extends IntercomRoute {
  @service declare messengerSettingsTargetUserProvider: MessengerSettingsTargetUserProvider;
  @service declare MessengerSettingsService: MessengerSettingsService;
  @service declare router: Router;
  @service declare appService: $TSFixMe;
  @service declare intl: IntlService;

  queryParams = {
    section: {
      refreshModel: false,
      replace: true,
    },
  };

  get titleToken() {
    return this.intl.t(`new-settings.submenu.channels.messenger`);
  }

  buildRouteInfoMetadata() {
    return {
      responsibleTeam: 'team-messenger',
    };
  }

  beforeModel() {
    if (
      !this.messengerSettingsTargetUserProvider.isUserType &&
      !this.messengerSettingsTargetUserProvider.isVisitor
    ) {
      this.messengerSettingsTargetUserProvider.setVisitorTarget();
    }
    this.MessengerSettingsService.preview.onPlatformChange('web');
  }

  afterModel(model: any, transition: Transition) {
    if (model.settings.lookAndFeel.activeBrand === model.settings.lookAndFeel.mobileBrand) {
      model.settings.lookAndFeel.activeBrand = model.settings.lookAndFeel.defaultBrand;
    }

    let { section } = transition.to.queryParams;
    section ||= DEFAULT_SECTIONS_FOR_TABS['general'];
    this.MessengerSettingsService.navigate('general', section, { changeUrl: false });
  }
}
